import { CARREGAR_PROFISSOES_SUCESSO } from '../actions/actionTypes';
import initialState from './initialState.reducer';

export default (state = initialState.profissoes, action) => {
  if (action.type === CARREGAR_PROFISSOES_SUCESSO)
    return action.profissoes;

  return state;
};